const smsMixin = {
  methods: {
    /**
     * Find select club.
     * @param {Array} array Club list.
     * @param {string} code C code of club.
     * @return {string|*}
     */
    findSelectedClub (array, code) {
      if (!array || !array.length) return ''
      return array.find(club => club.ccode === code)
    },
    /**
     * Extract text length as bytes.
     * @param {string} text
     * @return {number} Bytes length.
     */
    extractTextBytes (text) {
      return text.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/gm, '__').length
    }
  }
}

export default smsMixin



// WEBPACK FOOTER //
// ./src/features/sms/mixins/sms.mixin.js